import { render, staticRenderFns } from "./BankAccountNew.vue?vue&type=template&id=9c6e0404"
import script from "./BankAccountNew.vue?vue&type=script&lang=js"
export * from "./BankAccountNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports